import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";
import useNotification from "../components/notifications/useNotifications";

export default function useBatchListingsMutations(componentName = "useBatchListingsMutations") {
  const { get, post, put } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60; //1 minutes

  const { addNotification } = useNotification();

  const createBatch = useMutation(
    (body: any) => post(`/part/listings/multiple/batch`, body),
    {
      onSuccess: (data, _, __) => {
        // queryClient.invalidateQueries(["parts", "multiple"]);
        return data;
      },
    }
  );

  const bulkPublish = useMutation(
    (body: any) => post(`/bulklisting/publish`, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["parts"]);
        queryClient.invalidateQueries(["pagedTable"]);
      },
    }
  );

  const bulkRelist = useMutation(
    (body: any) => post(`/bulklisting/relist`, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["parts"]);
        queryClient.invalidateQueries(["pagedTable"]);
      },
    }
  );

  const cancelMutation = useMutation(
    (batchItemId: string) => put(`/bulklisting/batch-item/${batchItemId}/cancel`, null),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["pagedTable"] });
        queryClient.invalidateQueries({ queryKey: ["bulkListing", "stats"] });
        addNotification({ variant: "success", primaryText: "Listing cancelled" });
      },
      onError: () => {
        addNotification({ variant: "error", primaryText: "Failed to cancel listing" });
      },
    }
  );

  return {
    createBatch,
    bulkPublish,
    bulkRelist,
    cancelMutation,
  };
}
